import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=1a9a3741&scoped=true"
import script from "./Achievements.vue?vue&type=script&lang=js"
export * from "./Achievements.vue?vue&type=script&lang=js"
import style0 from "./Achievements.vue?vue&type=style&index=0&id=1a9a3741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a3741",
  null
  
)

export default component.exports